import Vue from "vue";
import { cloneDeep, get, omit, set } from "lodash";
import { getOrigin } from "@/helpers";
import { lossDateIsGreaterThan120Days } from "@/helpers/generalHelpers";
import ClaimsService from "@/services/claims.service";

export default Vue.extend({
  data() {
    return {
      errorMessage: "",
      lossFormData: {} as any
    };
  },
  methods: {
    async viewSendingXML(): Promise<void> {
      this.errorMessage = "";
      const newTab = window.open(
        `${getOrigin()}/loading-preview/noMessage`,
        "_blank"
      );
      try {
        const payload = cloneDeep(this.lossFormData);
        set(payload, "brk_pt", "VS");
        set(
          payload,
          "lossFormRequire.paymentOption",
          get(payload, "lossFormOtherInfo.FormInfo.paymentOption", "") || ""
        );
        const reasonForDelay = get(
          payload,
          "lossFormOtherInfo.FormInfo.ReasonForDelayInReport",
          ""
        );
        if (
          lossDateIsGreaterThan120Days(
            get(payload, "lossFormOtherInfo.FormInfo.LossDate")
          )
        ) {
          // Older claims (e.g. Issued) predate the 120-day mark without ever
          // having needed a delay reason; the API requires one whenever the
          // loss date is 120+ days before today, so send a placeholder.
          if (!reasonForDelay) {
            set(
              payload,
              "lossFormOtherInfo.FormInfo.ReasonForDelayInReport",
              "N/A"
            );
          }
        } else if (reasonForDelay) {
          set(payload, "lossFormOtherInfo.FormInfo.ReasonForDelayInReport", "");
        }
        payload.lossFormRequire = {
          ...payload.lossFormRequire,
          ...payload.formItem
        };
        const response = await ClaimsService.getSendingXML(
          omit(payload, ["mortgageInfo"])
        );
        const { rawXML } = response.data;
        if (!rawXML) {
          throw new Error("No sending XML returned.");
        }
        const blobUrl = URL.createObjectURL(
          new Blob([rawXML], { type: "text/xml" })
        );
        if (newTab) {
          newTab.location.href = blobUrl;
        }
      } catch (e) {
        newTab?.close();
        this.errorMessage =
          e instanceof Error ? e.message : "Error generating sending XML";
      } finally {
        this.$emit("scrollTop");
      }
    }
  }
});
